/**
 * 公告栏
 */
import { FC, useState, useEffect } from 'react'
import { Button, Form, Modal, NoticeBar } from 'antd-mobile'
import { SoundOutline } from 'antd-mobile-icons'
import { useTranslation } from "react-i18next";
import { isEmpty, stripHTMLTags } from '@/utils'
import { useStoreState } from '@/store'
import css from './index.module.less'


export const Notice: FC = () => {
  const { t } = useTranslation();
  const { centerConfig }: any = useStoreState();
  const [visible, setVisible] = useState(false)


  if (isEmpty(centerConfig.notice)) return null;

  const icon = process.env.REACT_APP_IDN_ENV === 'hw' ? <div className={css.Icon}></div> : <SoundOutline />;

  useEffect(() => {
    setVisible(true)
  }, [])

  return (
    <>
      <div onClick={() => setVisible(true)}>
        <NoticeBar
          className={'mgt-5 mgb-20'}
          content={stripHTMLTags(centerConfig.notice)}
          color='alert'
          icon={icon}
        />
      </div>

      <Modal
        visible={visible}
        // showCloseButton
        // onClose={() => setVisible(false)}
        destroyOnClose
        content={
          <>
            <div dangerouslySetInnerHTML={{ __html: centerConfig.notice }}></div>
            <div className={'mgt-10'}>
              <Button block color='primary' className={'font-14'} onClick={() => setVisible(false)}>{t('common.know')}</Button>
            </div>
          </>
        }
      />
    </>
  )
}
